<template>
  <div>
    <OtpModal
      v-if="captchaReady && showPopup && email"
      :dictionary="dictionary"
      :configuration="configuration"
      :email="email"
      :can-resend="canResend"
      :can-revalidate="canRevalidate"
      @resend="resend"
      @succeess="otpModalSuccess"
      @resend-error="handleResendError"
      @revalidate-error="handleRevalidateError"
      @otp-blocked-error="handleOtpBlockedError"
      @close-modal="onCloseModal"></OtpModal>

    <ModalOverlay
      v-model="errorOtp"
      background-class="b-pop-up--alert-success b-pop-up__holder"
      header-background-class="b-pop-up__header"
      :no-close-backdrop="true"
      :hide-close-btn="true">
      <template #header>
        <div class="b-pop-up__header__title">
          {{ dictionary.defaultErrorTitle }}
        </div>
      </template>
      <template #body>
        <div class="b-pop-up__alert-success__content">
          <div
            class="b-pop-up__alert-success__icon b-pop-up__alert-success__icon--warning"></div>
          <div class="b-pop-up__alert-success__content__container">
            <div class="b-pop-up__alert-success__title">
              <template v-if="otpBlockedError">
                {{ dictionary.otpBlockedErrorMessage }}
              </template>
              <template v-else>{{ dictionary.defaultErrorMessage }}</template>
            </div>
            <div class="d-flex justify-content-center">
              <button
                id="restart"
                type="button"
                class="btn btn-primary-orange"
                :title="dictionary.buttonRestartText"
                @click="onClickRestart">
                <span>{{ dictionary.buttonRestartText }}</span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </ModalOverlay>
  </div>
</template>

<script>
import { checkCaptcha } from './../../lib/lib'
import postRequestHandler from './../../lib/postRequestHandler'
import ModalOverlay from './ModalOverlay.vue'
import OtpModal from './Otp/OtpModal.vue'
import { useBookingStore } from './../store/BookingStore'

export default {
  components: {
    ModalOverlay,
    OtpModal,
  },
  props: {
    dictionary: {
      default() {
        return {}
      },
      type: Object,
    },
    configuration: {
      default() {
        return {}
      },
      type: Object,
    },
  },
  emits: ['success', 'loading', 'otpBlockedError'],
  setup() {
    return { store: useBookingStore() }
  },
  data() {
    return {
      captchaReady: false,
      showPopup: false,
      errorMsgs: [],
      isLoading: false,
      otpcode: '',
      email: '',
      errorOtp: false,
      canResend: true,
      canRevalidate: true,
      otpBlockedError: false,
    }
  },

  mounted() {
    checkCaptcha(() => {
      this.captchaReady = true
    })
  },
  methods: {
    onClickRestart() {
      const { pathname } = window.location
      window.location.assign(pathname)
    },

    async start(email) {
      if (!email) {
        return false
      }
      if (this.isLoading) {
        return false
      }

      this.email = email

      this.isLoading = true
      this.$emit('loading', true)

      const postData = {
        email: this.email,
        userSessionId: this.store.bookingProgress.usersessionId,
      }

      await postRequestHandler({
        postData,
        endpoint: this.configuration.requestOtpHandler,
        successCallback: this.handleRequestOtpSuccess,
        errorCallback: this.handleRequestOtpError,
        refreshTokenHandler: this.configuration.refresh,
        captchaAction: this.configuration.requestOtpCaptchaAction,
      })
    },

    handleRequestOtpSuccess(data) {
      this.isLoading = false
      this.$emit('loading', false)

      // verificationCode found so proceed without popup
      if (data.data.verificationCode) {
        this.closeModal()
        this.$emit('success', data.data.verificationCode)
      } else {
        const { canResend, canRevalidate } = data.data
        if (!canResend && !canRevalidate) {
          this.handleOtpBlockedError()
          return
        }
        this.canResend = canResend
        this.canRevalidate = canRevalidate

        this.showPopup = true
      }
    },
    handleRequestOtpError() {
      this.isLoading = false
      this.$emit('loading', false)
      this.errorOtp = true
    },
    otpModalSuccess(verificationCode) {
      this.closeModal()
      this.$emit('success', verificationCode)
    },
    openModal() {
      this.showPopup = true
    },
    closeModal() {
      this.showPopup = false
    },
    resend() {
      this.start(this.email)
    },
    handleOtpBlockedError() {
      this.otpBlockedError = true
      this.closeModal()
      this.handleRequestOtpError()
      this.$emit('otpBlockedError')
    },
    handleResendError() {
      this.canResend = false
    },
    handleRevalidateError() {
      this.canRevalidate = false
    },
    onCloseModal() {
      this.showPopup = false
    },
  },
}
</script>
